module.exports = __webpack_public_path__ + "img/11_44.b9f1ea16.png";